<template>
    <div class="l-wrap employer-holder">
        <div class="l-constrained l-content">

            <el-container v-loading="loading">
                <el-main v-if="errorMessage !== ''">
                    <el-alert type="error" title="Error: ">{{ errorMessage }}</el-alert>
                </el-main>
                <el-main v-else-if="errorMessage === ''">
                    <slot/>
                </el-main>
            </el-container>

        </div>
    </div>
</template>

<script>
    export default {
        props: {
            initialized: Boolean,
            errorMessage: String,
        },
        computed: {
            loading() { return this.errorMessage === '' && !this.initialized; },
        },
    };
</script>
